import { HttpClient } from './httpClient'
import * as ApiEvents from './apiEvents'

const deleteEvent = (eventMessage) => ({
    eventType: ApiEvents.DELETE_C88_ENTITY_UK,
    eventTime: Date.now(),
    eventMessage,
});

export const deleteMerchandise = (merchandiseId) => {
    let dataSent = deleteEvent({
        shipmentId: window.shipmentId,
        descriptionOfMerchandise: {
            merchandiseLineItems: [
                {
                    merchandiseId: merchandiseId
                }
            ]
        }
    });

    return HttpClient.post(dataSent)
        .catch(error => {
            console.error(`Error from axios on FIELD delete: `, error)
        })
}

export const deleteInvoiceLineItem = (invoiceId) => {
    let dataSent = deleteEvent({
        shipmentId: window.shipmentId,
       
        invoices: [
                {
                    shipmentId: window.shipmentId,
                    invoiceId: invoiceId
                }
            ]
        
    });

    return HttpClient.post(dataSent)
        .catch(error => {
            console.error(`Error from axios on FIELD delete: `, error)
        })

}

export const deleteNotesItem = (noteId) => {
    let dataSent = {
        eventType: ApiEvents.DELETE_SHIPMENT_NOTES,
        eventTime: Date.now(),
        eventMessage: 
                {
                    shipmentId: window.shipmentId,
                    noteId
                }
            
        
        };

    return HttpClient.post(dataSent)
        .catch(error => {
            console.error(`Error from axios on FIELD delete: `, error)
        })

}


export const deleteMerchandiseDuty = (merchandiseId, merchandiseDutyId) => {
    let dataSent = deleteEvent({
        shipmentId: window.shipmentId,
        descriptionOfMerchandise: {
            merchandiseLineItems: [
                {
                    merchandiseId,
                    C88MerchandiseDuty: [{
                        merchandiseId,
                        merchandiseDutyId
                    }]
                }
            ]
        }
    });

    return HttpClient.post(dataSent)
        .catch(error => {
            console.error(`Error from axios on FIELD delete: `, error)
        })
}



export const deleteMerchandiseInfo = (merchandiseId, infoId) => {
    let dataSent = deleteEvent({
        shipmentId: window.shipmentId,
        descriptionOfMerchandise: {
            merchandiseLineItems: [
                {
                    merchandiseId,
                    additionalInfo: [{
                        merchandiseId,
                        infoId
                    }]
                }
            ]
        }
    });

    return HttpClient.post(dataSent)
        .catch(error => {
            console.error(`Error in delete deleteMerchandiseInfo : `, error)
        })
}


export const deleteMerchandiseAIInfo = ( infoId) => {
    let dataSent = deleteEvent({
      shipmentId: window.shipmentId,
      descriptionOfMerchandise: {
        merchandiseLineItems: [
          {
            aiStatementUkInfo: [
              {
                infoId,
              },
            ],
          },
        ],
      },
    });

    return HttpClient.post(dataSent)
        .catch(error => {
            console.error(`Error in delete deleteMerchandiseInfo : `, error)
        })
}

export const deleteSumaryItem = (infoId) =>{
    let dataSent = deleteEvent({
      descriptionOfMerchandise: {
        merchandiseLineItems: [
          {
           
            previousDocumentInfo: [
                {
                    infoId
                }
              ]
          },
        ],
      },
      shipmentId: window.shipmentId,
    });
   
    return HttpClient.post(dataSent)
        .catch(error => {
            console.error(`Error in delete deleteMerchandiseInfo : `, error)
        }) 
}



export const  deleteAddionalInfoHeader = (id , infoID) => {
    let dataSent = deleteEvent({
        shipmentId: window.shipmentId,
        additionalInfos: [
            {
              shipmentId: id,
              infoId: infoID
            }
          ]
       
    });

    return HttpClient.post(dataSent)
        .catch(error => {
            console.error(`Error in delete deleteMerchandiseInfo : `, error)
        })

}



export const  deleteAIStatementAndCodeInfoHeader = (id , infoId) => {
    let dataSent = deleteEvent({
        shipmentId: window.shipmentId,
        aiStatementUkInfo: [
            {
                shipmentId: window.shipmentId,
                infoId: infoId
            }
          ]
       
    });
   return dataSent
}

export const deleteSupOfficeDetails = (supOffice) =>{
    let dataSent = deleteEvent({
        shipmentId: window.shipmentId,
        supOffice: {
            id: supOffice.id
         }
       
    });

    return HttpClient.post(dataSent)
        .catch(error => {
            console.error(`Error in delete deleteMerchandiseInfo : `, error)
        })

}


export const deleteWarehouseDetails = (warehouse) =>{
    let dataSent = deleteEvent({
        shipmentId: window.shipmentId,
        warehouse: {
            id: warehouse.id
         }
       
    });

    return HttpClient.post(dataSent)
        .catch(error => {
            console.error(`Error in delete deleteMerchandiseInfo : `, error)
        })

}
